export default __webpack_public_path__ + "static/media/logo_company_generic_270_160_px.9644ff65.jpg";